import { Injectable } from '@angular/core';
import { IQuote, ISector, ISegment, ISegmentInformation, SectorXCategory } from "libraries/service/resources/airTrip/IGetAirTripQuotes";

@Injectable()
export class LowCostCompanyService {

    /**
     * If selected journeys contain a sector with 'lowcost' === xCategory, then the quote is unbookable.
     * @param quote the quote to check
     * @param selectedJourneysIds selected journeys for quote
     * @return true if quote is unbookable, false otherwise
     */
    public hasLcc(quote: IQuote, selectedJourneysIds?: string[]): boolean {
        const mySegments: ISegment[] = Object.values(quote.segment);
        const hasLcc : ISector = this.findSectorWithLcc(quote, mySegments, selectedJourneysIds);

        // #31782 : still caring about selectedJourneysIds, but if selectedSectors are not found on quote,
        // checking first journeys to get info
        if(hasLcc === undefined){
            return !!this.findSectorWithLcc(quote, mySegments, mySegments.map((segment: ISegment): string => segment.journey[0]));
        }

        return !!hasLcc;
    }

    public findSectorWithLcc(quote: IQuote, mySegments: ISegment[], selectedJourneysIds?: string[]): ISector {
        // either selected journeys, or first journey of each segment
        const myJourneysIds: string[] = selectedJourneysIds || mySegments.map((segment: ISegment): string => segment.journey[0]);

        const selectedSectors: ISector[] = [].concat(
                ...mySegments.map((segment: ISegment, segIndex: number) : ISegmentInformation => segment[myJourneysIds[segIndex]])
                .filter(Boolean)
                .map((journey: ISegmentInformation): ISector[] => journey.sector));

        return selectedSectors.find((sector: ISector): boolean => sector.xCategory === SectorXCategory.lowcost);
    }

}
